import axios from "axios";
import { baseUrl } from "../config/app.config";

export const InsertUpdateCallLog = async logDetails => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/CallCenter/InsertAgentCallDetails",
      data: logDetails
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const UpdateAgentCallDetails = async logDetails => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/CallCenter/UpdateAgentCallDetails",
      data: logDetails
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetCategoriesAndCCLinks = async () => {
  let result = { error: false, data: "" };
  try {
    var response = await axios.get(
      baseUrl + "/api/CallCenter/GetCategoriesAndCCLinks"
    );
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetCallDetails = async (emailid, date) => {
  let result = { error: false, data: "" };
  try {
    var response = await axios.get(
      baseUrl +
        "/api/CallCenter/GetCallDetails?email=" +
        emailid +
        "&date=" +
        date
    );
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetAgentCallSummary = async (emailid, date) => {
  let result = { error: false, data: "" };
  try {
    var response = await axios.get(
      baseUrl +
        "/api/CallCenter/GetAgentCallSummary?email=" +
        emailid +
        "&date=" +
        date
    );
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};
